























import { defineComponent, computed } from "@vue/composition-api";
import { useVuex } from "@/hooks/use-vuex";

export default defineComponent({
  setup() {
    const { store } = useVuex();
    const status = computed(() => store.state.Loading.status);
    const loadingOverlay = computed(() => store.state.Loading.loadingOverlay);
    const loading = computed(() => store.state.Loading.loading);
    const redirectButton = computed(() => store.state.Loading.redirectButton);

    return {
      status,
      loadingOverlay,
      loading,
      redirectButton
    };
  }
});
